import { moneyFromMinor } from '../../../shared/money/exact-money.js';

export function readVerificationAccess(response) {
  const access = response?.verificationAccess;
  if (!access || ['verified', 'allowLiveAccount', 'allowDeposit', 'allowWithdrawal'].some((key) => typeof access[key] !== 'boolean')
    || !Number.isInteger(access.verificationDays)
    || ['limit', 'used', 'reserved', 'remaining'].some((key) => !moneyFromMinor(access[key]))
    || ['deadlineAt', 'firstDepositAt'].some((key) => access[key] !== null && (typeof access[key] !== 'string' || Number.isNaN(new Date(access[key]).getTime())))
    || (access.depositBlockReason !== null && typeof access.depositBlockReason !== 'string')
    || (access.profileStatus !== null && typeof access.profileStatus !== 'string')) {
    throw new Error('verificationAccess.invalidResponse');
  }
  return access;
}
